<form class="" #termsForm="ngForm" action="javascript:">
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'admin.terms.show.terms information'|translate">
        <div class="row">
          <div class="col-3">
            <div class="row">
              <div class="form-group col-md-12">
                <div class="row">
                  <div class="col-12">
                    <label for="uploaderFile">{{"doctrine.download_files.file" | translate}}   <span
                      class="star">*</span>
                      <div class="preloader3 loader-block mx-auto" *ngIf="uploader.isUploading">
                        <div class="circ1 loader-success"></div>
                        <div class="circ2 loader-success"></div>
                        <div class="circ3 loader-success"></div>
                      </div>
                    </label>
                  </div>
                </div>
                <label [ngClass]="{'d-none':imageFileName}" class="custom-file" *ngIf="!uploader.isUploading">
                  <input name="file" #generalTermFile="ngModel" ngModel type="file" ng2FileSelect [uploader]="uploader"
                         class="custom-file-input"
                         (change)="uploadFile($event)" id="uploaderFile" accept="application/pdf">
                  <span class="custom-file-control-upload"
                        *ngIf="uploader.queue.length==0">{{"global.upload"|translate}}</span>
                  <span class="custom-file-control-upload"
                        *ngIf="uploader.queue.length > 0 || isFileEdit">{{"global.change"|translate}}</span>
                  <span
                    class="custom-file-control">{{(uploader.queue.length > 0) ? uploader.queue[uploader.queue.length - 1].file.name : ''}}</span>
                  <div class="messages text-danger"
                       *ngIf="generalTermFile.invalid && generalTermFile.dirty && generalTermFile.errors?.required">{{'errors.required'|translate}}
                  </div>
                  <div class="messages text-danger"
                       *ngIf="isNotAdd && !imageFileName">{{'errors.file_type_invalid'|translate}}
                  </div>
                </label>
                <div class="row" *ngIf="imageFileName && !uploader.isUploading">
                  <div class="col-sm-9">
                    {{imageFileName}}
                  </div>
                  <div *ngIf="imageFileName" class="col-sm-1">
                    <button (click)="changeImage($event)"
                            class="btn btn-primary waves-effect waves-light">{{'global.change'|translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group col-md-12">
              <label for="name">{{"doctrine.general_terms.comment" | translate}}</label>
              <input name="comment"
                     #generalTermComment="ngModel"
                     id="name"
                     class="form-control"
                     [(ngModel)]="generalTerm.comment">
              <span class="form-bar"></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-5">
            <label for="terms">{{"doctrine.general_terms.terms" | translate}}   <span class="star">*</span></label>
            <quill-editor required #editor="ngModel" [modules]="modules" name="terms"
                          [(ngModel)]="generalTerm.terms" id="terms"></quill-editor>
            <div class="messages text-danger"
                 *ngIf="editor.invalid && editor.dirty && editor.errors?.required">{{'errors.required'|translate}}
            </div>
          </div>
        </div>
        <br>
        <br>
        <div class="row">
          <div class="col-12">
            <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
              <div class="text-end">
                <button (click)="submitItem(false)" class="btn btn-link"
                        type="button">{{'global.cancel'|translate}}</button>
                <button type="button" class="btn btn-primary ripple light"
                        [disabled]="(editor.invalid && editor.dirty && editor.errors?.required) || !imageFileName"
                        (click)="submitItem(true)">{{(isEdit ? 'global.actions.save' : 'global.add')|translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </app-card>
    </div>
  </div>
</form>
